const liveIcon = document.querySelectorAll('.live-icon');

liveIcon.forEach((ele) => {
  const liveIconTimeline = gsap.timeline({ repeat: -1, yoyo: true });
  const animatedCenter = ele.querySelector('.live-icon__center');
  const animatedInner = ele.querySelectorAll('.live-icon__inner');
  const animatedOuter = ele.querySelectorAll('.live-icon__outer');

  liveIconTimeline
    .to(animatedCenter, { duration: 0.3, opacity: 1, ease: 'none' })
    .to(animatedInner, { duration: 0.3, opacity: 1, ease: 'none' })
    .to(animatedOuter, { duration: 0.3, opacity: 1, ease: 'none' });
});
